import { Button } from "design-system/atoms/Button"
import { ArchiveRestore } from "lucide-react"
import { useArchiveCampaignMutation } from "modules/campaigns/hooks/useArchiveCampaignMutation"
import { useUnarchiveCampaignMutation } from "modules/campaigns/hooks/useUnarchiveCampaignMutation"
import { useTranslation } from "react-i18next"
import { CampaignResponseDataSchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"

type Props = {
  campaign: z.infer<typeof CampaignResponseDataSchema>
}

export function ArchivedCampaignBanner({ campaign }: Props) {
  const { t } = useTranslation()
  const { mutateAsync: unarchiveCampaign, isPending: isUnarchiving } = useUnarchiveCampaignMutation(
    campaign.id,
  )
  const { mutateAsync: archiveCampaign, isPending: isArchiving } = useArchiveCampaignMutation(
    campaign.id,
  )

  if (!campaign.archivedAt) return null

  function onUnarchive() {
    unarchiveCampaign().then(() => {
      toast.success(t("campaigns.detail.unarchiveSuccess"), {
        action: {
          label: t("shared.undo"),
          onClick: () => archiveCampaign(),
        },
      })
    })
  }

  return (
    <div className="sticky z-50 top-14 h-16 flex flex-row items-center gap-2 p-4 bg-negative-soft/50 sm:justify-between justify-start backdrop-blur-xl">
      <div className="flex items-center gap-2">
        <span className="text-sm line-clamp-1" title={t("campaigns.options.archiveDescription")}>
          {t("campaigns.options.archiveDescription")}
        </span>
      </div>
      <Button variant="outline" onClick={onUnarchive} disabled={isUnarchiving || isArchiving}>
        <ArchiveRestore className="w-4 h-4" />
        {t("campaigns.options.unarchive")}
      </Button>
    </div>
  )
}
